import React from 'react';
import { Modal, Space, Alert } from 'antd';
import { ExclamationCircleOutlined, WarningOutlined } from '@ant-design/icons';
import type { DeviceGroup } from '../../types';

interface DeleteDeviceGroupModalProps {
  isOpen: boolean;
  deviceGroup: DeviceGroup | null;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteDeviceGroupModal: React.FC<DeleteDeviceGroupModalProps> = ({ 
  isOpen, 
  deviceGroup, 
  onConfirm, 
  onCancel 
}) => {
  if (!deviceGroup) return null;

  return (
    <Modal
      className="themed-confirm"
      title={
        <Space>
          <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />
          Delete Device Group
        </Space>
      }
      open={isOpen}
      onOk={onConfirm}
      onCancel={onCancel}
      okText="Yes, Delete"
      cancelText="Cancel"
      okButtonProps={{ danger: true }}
      destroyOnClose
    >
      <div className="py-4">
        <p className="mb-4 text-muted-foreground">
          Are you sure you want to delete the following device group? This action cannot be undone.
        </p>
        
        <div className="bg-muted p-4 rounded-md border border-border mb-4">
          <div className="font-medium text-foreground">{deviceGroup.name}</div>
          <div className="text-sm text-muted-foreground">ID: {deviceGroup.id}</div>
          <div className="text-sm text-muted-foreground">Contains {deviceGroup.deviceCount} devices</div>
        </div>

        <Alert
          message="Important Notice"
          description="Please ensure that all devices are removed from this group before attempting to delete it."
          type="warning"
          icon={<WarningOutlined />}
          showIcon
        />
      </div>
    </Modal>
  );
};

export default DeleteDeviceGroupModal;
